// Helper function to get correct image path with base path
export const getImagePath = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Get base path from environment or default to /
    const basePath = process.env.REACT_APP_BASE_PATH || '/';
    
    // Return full path (avoid double slashes)
    if (basePath === '/') {
        return `/${cleanPath}`;
    }
    return `${basePath}/${cleanPath}`;
};

// Alternative: use process.env.PUBLIC_URL if available
export const getImagePathPublic = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Use PUBLIC_URL if available, otherwise use base path
    const baseUrl = process.env.PUBLIC_URL || process.env.REACT_APP_BASE_PATH || '/';
    
    // Avoid double slashes
    if (baseUrl === '/') {
        return `/${cleanPath}`;
    }
    return `${baseUrl}/${cleanPath}`;
};

